import { allDestinations } from "@/config/global.strings";
import { allRules, Port, Route } from "@/config/rules";
import { useBookingStore } from "@/store/booking";
import { computed } from "vue";


const useRoutes = () => {
    const bookingStore = useBookingStore();

    const destinationNames = computed(() => {
        return bookingStore.getDestinationNames;
    });

    const hasFrom = () => {
        return allDestinations.includes(bookingStore.getBooking.outward.from);
    };

    const hasTo = () => {
        return allDestinations.includes(bookingStore.getBooking.outward.to);
    };

    const outwardDestinations = computed(() => {
        const ports = allRules
            .filter(
                (rule) => rule.modeOfTravel === bookingStore.getBooking.modeOfTravel
            )
            ?.flatMap((r) => r.ports) as Port[];

        return ports.filter((rule) => (rule.returnOnly ?? false) == false);
    });

    const returnDestinations = computed(() => {
        const ports = allRules
            .filter(
                (rule) => rule.modeOfTravel === bookingStore.getBooking.modeOfTravel
            )
            ?.flatMap((r) => r.ports) as Port[];

        return ports.filter((rule) => (rule.outwardOnly ?? false) == false);
    });

    const disableRoute = (value: string) => {
        const ports = allRules
            .filter(
                (rule) => rule.modeOfTravel === bookingStore.getBooking.modeOfTravel
            )
            ?.flatMap((r) => r.ports) as Port[];

        const destinations = ports
            .filter((p) => p.code == bookingStore.getBooking.outward.from)
            ?.flatMap((d) => d.destinations) as Route[];

        return !destinations?.some((route) => route.code === value);
    };

    const from = computed({
        get(): string {
            const value = bookingStore.getBooking.outward.from;
            updateTo(value);
            return value;
        },
        set(value: string) {
            bookingStore.clearRoutes();
            bookingStore.setFromDestination(
                value,
                bookingStore.getBooking.modeOfTravel
            );

            updateTo(value);
        },
    });

    const updateTo = (value: string) => {
        //check in rules file if there is only one "to destination" 
        //available depending on the selected from destination
        //if true then autoselect that destination as "to destination"
        const port = allRules.find(r => r.modeOfTravel === bookingStore.getBooking.modeOfTravel)
            ?.ports.find(p => p.code === value);

        if (port?.destinations.length === 1) {
            const toDestination = port.destinations[0].code;

            bookingStore.setToDestination(
                toDestination,
                bookingStore.getBooking.modeOfTravel
            );
        }
    }

    const to = computed({
        get(): string {
            return bookingStore.getBooking.outward.to;
        },
        set(value: string) {
            bookingStore.setToDestination(
                value,
                bookingStore.getBooking.modeOfTravel
            );
        },
    });

    return {
        destinationNames,
        outwardDestinations,
        from,
        returnDestinations,
        to,
        disableRoute,
        hasFrom,
        hasTo
    }
}

export default useRoutes;